<div class="content-footer">
  <p>&copy; {{ currentYear }}. All rights reserved.</p>
</div>